<template>
  <b-modal
    title="Modification d'élément"
    size="xl"
    :modal-class="'base-modal middle-size'"
    centered
    ref="editElementModal"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    :lazy="true"
    @hide="close"
  >
    <b-container fluid>
      <div class="row">
        <div class="col content-editor">
          <div :class="{'disabled-action': disabled}">
            <div v-if="this.element" class="btn-toolbar">
              <b-button-group>
                <b-dropdown
                  :style="[
                    {
                      fontFamily: this.getSelectedFontFamily().family,
                      fontSize: '12px',
                      textOverflow: 'ellipsis'
                    }
                  ]"
                  variant="outline-primary"
                  class="font-type"
                >
                  <template slot="button-content">
                    {{ this.getSelectedFontFamily().name | truncate(10) }}
                  </template>
                  <b-dropdown-item
                    v-for="fm in this.fontFamily"
                    :key="fm.name"
                    :active="fm.state"
                    :style="[{ fontFamily: fm.family, fontSize: '11px' }]"
                    @click.prevent="fontFamilyClick(fm.family)"
                    >{{ fm.name }}</b-dropdown-item
                  >
                </b-dropdown>
                <b-dropdown
                  :text="this.getSelectedFontSize()"
                  variant="outline-primary"
                  class="font-size"
                >
                  <b-dropdown-item
                    v-for="size in this.fontSize"
                    :key="size.value"
                    :active="size.state"
                    :style="[{ fontFamily: 'Arial', fontSize: '11px' }]"
                    @click.prevent="fontSizeSelected(size.value)"
                    >{{ size.value }}</b-dropdown-item
                  >
                </b-dropdown>
              </b-button-group>
              <b-button-group>
                <b-button
                  :pressed="this.fontWeight.state"
                  @click.prevent="fontWeightClick()"
                  class="icon-btn"
                  variant="outline-primary"
                >
                  <font-awesome-icon :icon="['fas', 'bold']" />
                </b-button>
                <b-button
                  :pressed="this.fontStyle.state"
                  @click.prevent="fontStyleClick()"
                  class="icon-btn"
                  variant="outline-primary"
                >
                  <font-awesome-icon :icon="['fas', 'italic']" />
                </b-button>
              </b-button-group>
              <b-button-group>
                <b-dropdown
                  id="font-color-picker"
                  class="icon-btn"
                  variant="outline-primary"
                >
                  <template slot="button-content">
                    <font-awesome-icon v-bind:style="{ color }" :icon="['fas', 'font']" />
                  </template>
                  <div class="color-picker">
                    <color-picker
                      v-if="showFontColorPicker"
                      :sucker-hide="true"
                      :color="color"
                      @changeColor="changeColor"
                    />
                  </div>
                </b-dropdown>
                <b-dropdown
                  id="background-color-picker"
                  class="icon-btn"
                  variant="outline-primary"
                >
                  <template slot="button-content">
                    <font-awesome-icon
                      v-bind:style="{ backgroundColor }"
                      :icon="['fas', 'fill-drip']"
                    />
                  </template>
                  <div class="color-picker">
                    <color-picker
                      v-if="showBackgroundColorPicker"
                      :sucker-hide="true"
                      :color="backgroundColor"
                      colors-history-key="background-color-history"
                      @changeColor="changeBackgroundColor"
                    />
                  </div>
                </b-dropdown>
              </b-button-group>
              <b-button-group>
                <b-button
                  v-for="align in this.justifyContent"
                  :key="align.type"
                  @click.prevent="textAlignClick(align.type)"
                  :pressed="align.state"
                  class="icon-btn"
                  variant="outline-primary"
                >
                  <font-awesome-icon :icon="['fas', align.icon]" />
                </b-button>
              </b-button-group>
              <b-button
                  v-if="!this.showMore"
                  @click.prevent="() => showMore = !showMore"
                  class="icon-btn"
                  variant="outline-primary"
                >
                  Espacements
              </b-button>
            </div>
          </div>
          <edit-element-drop
            v-if="this.active && this.element && this.element.type === 'drop'"
            :data="element"
            @dropEdit="handleDropEdit"
            @columnChange="handleColumnChange"
            @valueChange="handleValueChange"
            @deleteData="handleDeleteData"
          />
          <edit-element-text
            v-else-if="this.active && this.element && this.element.type === 'text'"
            :data="element"
            @textEdit="handleTextEdit"
          />
        </div>
        <transition name="slide-fade">
          <div v-if="this.showMore" class="col-6 px-0" style="height: 550px; overflow-y: auto;">
            <div class="btn-toolbar float-right">
              <b-button
                  @click.prevent="() => showMore = !showMore"
                  class="icon-btn"
                  variant="outline-danger"
                >
                  Fermer
              </b-button>
            </div>
            <ul class="wrapper-setting px-0">
              <li v-if="this.element.type !== 'drop'" class="setting-option">
                <div class="option-details">
                  <h3>Espacement intérieurs (padding)</h3>
                  <p class="description">
                    Modifie les espacements intérieurs (en haut, à droite, en bas et à gauche) de l'élément. Exprimé en pixels.
                  </p>
                </div>
                <div class="option-field">
                  <div class="multi-input">
                    <b-input-group class="mb-2" size="sm" style="width: 100px">
                      <template v-slot:prepend>
                        <b-input-group-text><font-awesome-icon :icon="['fas', 'arrow-up']" /></b-input-group-text>
                      </template>
                      <b-form-input min="0"
                      type="number"
                      :value="paddingTop"
                      @change="(value) => updateStyle('paddingTop', value, 'px')"
                      ></b-form-input>
                    </b-input-group>
                    <b-input-group class="mb-2" size="sm" style="width: 100px">
                      <template v-slot:prepend>
                        <b-input-group-text><font-awesome-icon :icon="['fas', 'arrow-right']" /></b-input-group-text>
                      </template>
                      <b-form-input min="0"
                      type="number"
                      :value="paddingRight"
                      @change="(value) => updateStyle('paddingRight', value, 'px')"
                      ></b-form-input>
                    </b-input-group>
                    <b-input-group class="mb-2" size="sm" style="width: 100px">
                      <template v-slot:prepend>
                        <b-input-group-text><font-awesome-icon :icon="['fas', 'arrow-down']" /></b-input-group-text>
                      </template>
                      <b-form-input min="0"
                      type="number"
                      :value="paddingBottom"
                      @change="(value) => updateStyle('paddingBottom', value, 'px')"
                      ></b-form-input>
                    </b-input-group>
                    <b-input-group class="mb-2" size="sm" style="width: 100px">
                      <template v-slot:prepend>
                        <b-input-group-text><font-awesome-icon :icon="['fas', 'arrow-left']" /></b-input-group-text>
                      </template>
                      <b-form-input min="0"
                      type="number"
                      :value="paddingLeft"
                      @change="(value) => updateStyle('paddingLeft', value, 'px')"
                      ></b-form-input>
                    </b-input-group>
                  </div>
                </div>
              </li>
              <li class="setting-option">
                <div class="option-details">
                  <h3>Espacement extérieurs</h3>
                  <p class="description">
                    Modifie les espacements extérieurs (en haut et en bas) de l'élément. Exprimé en pixels.
                  </p>
                </div>
                <div class="option-field">
                  <div class="multi-input">
                    <b-input-group class="mb-2" size="sm" style="width: 100px">
                      <template v-slot:prepend>
                        <b-input-group-text><font-awesome-icon :icon="['fas', 'arrow-up']" /></b-input-group-text>
                      </template>
                      <b-form-input min="0"
                      type="number"
                      :value="marginTop"
                      @change="(value) => updateStyle('marginTop', value, 'px', true)"
                      ></b-form-input>
                    </b-input-group>
                    <b-input-group class="mb-2" size="sm" style="width: 100px">
                      <template v-slot:prepend>
                        <b-input-group-text><font-awesome-icon :icon="['fas', 'arrow-right']" /></b-input-group-text>
                      </template>
                      <b-form-input min="0"
                      type="number"
                      :value="marginRight"
                      @change="(value) => updateStyle('marginRight', value, 'px', true)"
                      ></b-form-input>
                    </b-input-group>
                    <b-input-group class="mb-2" size="sm" style="width: 100px">
                      <template v-slot:prepend>
                        <b-input-group-text><font-awesome-icon :icon="['fas', 'arrow-down']" /></b-input-group-text>
                      </template>
                      <b-form-input min="0"
                      type="number"
                      :value="marginBottom"
                      @change="(value) => updateStyle('marginBottom', value, 'px', true)"
                      ></b-form-input>
                    </b-input-group>
                    <b-input-group class="mb-2" size="sm" style="width: 100px">
                      <template v-slot:prepend>
                        <b-input-group-text><font-awesome-icon :icon="['fas', 'arrow-left']" /></b-input-group-text>
                      </template>
                      <b-form-input min="0"
                      type="number"
                      :value="marginLeft"
                      @change="(value) => updateStyle('marginLeft', value, 'px', true)"
                      ></b-form-input>
                    </b-input-group>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </transition>
      </div>
    </b-container>

    <div slot="modal-footer" class="w-100">
      <div class="footer-action float-right">
        <b-button
          variant="outline-primary"
          size="md"
          class="mx-2"
          @click="close"
        >
          Annuler
        </b-button>
        <b-button
          variant="primary"
          size="md"
          @click="saveChanges"
        >
          Valider
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import editElementDrop from '../edit/editElementDrop'
import editElementText from '../edit/editElementText'
import { mapActions, mapGetters } from 'vuex'
import { fontSizes, defaultElementStyle } from '../../../config/constanteUse'
import colorPicker from '@caohenghu/vue-colorpicker'
import iconBase from '../../icons/iconBase'

const {paddingTop, paddingRight, paddingBottom, paddingLeft, marginTop, marginBottom, marginLeft, marginRight} = defaultElementStyle

export default {
  components: {
    editElementDrop,
    editElementText,
    colorPicker,
    iconBase
  },
  data () {
    return {
      paddingTop,
      paddingBottom,
      paddingRight,
      paddingLeft,
      marginTop,
      marginBottom,
      marginLeft,
      marginRight,
      showMore: false,
      element: null,
      elindex: null,
      active: false,
      context: null,
      changedValue: [],
      deletedData: [],
      justifyContent: [
        { icon: 'align-left', type: 'flex-start', state: false },
        { icon: 'align-center', type: 'center', state: false },
        { icon: 'align-right', type: 'flex-end', state: false }
      ],
      fontStyle: {
        name: 'italic', state: false
      },
      fontWeight: {
        name: 'bold', state: false
      },
      fontFamily: [
        { name: 'Arial', family: 'Arial, Helvetica, sans-serif', state: true },
        { name: 'Arial Black', family: '"Arial Black", Gadget, sans-serif', state: false },
        { name: 'Impact', family: 'impactregular', state: false },
        { name: 'Comic Sans MS', family: '"Comic Sans MS", cursive, sans-serif', state: false },
        { name: 'Courier New', family: '"Courier New", Courier, monospace', state: false },
        { name: 'Georgia', family: 'Georgia, serif', state: false },
        { name: 'Lucida Console', family: '"Lucida Console", Monaco, monospace', state: false },
        { name: 'Lucida Sans Unicode', family: '"Lucida Sans Unicode", "Lucida Grande", sans-serif', state: false },
        { name: 'Open Sans', family: '"Open sans", Arial, sans-serif', state: false },
        { name: 'Palatino Linotype', family: '"Palatino Linotype", "Book Antiqua", Palatino, serif', state: false },
        { name: 'Tahoma', family: 'Tahoma, Geneva, sans-serif', state: false },
        { name: 'Times New Roman', family: '"Times New Roman", Times, serif', state: false },
        { name: 'Trebuchet MS', family: '"Trebuchet MS", Helvetica, sans-serif', state: false },
        { name: 'Verdana', family: 'Verdana, Geneva, sans-serif', state: false },
        { name: 'Corbel', family: 'Corbel', state: false },
        { name: 'Comic Sans MS', family: 'Comic Sans MS', state: false },
        { name: 'Calibri', family: 'Calibri', state: false },
        { name: 'Lucida Sans', family: 'Lucida Sans', state: false },
        { name: 'Agency FB', family: 'Agency FB', state: false },
        { name: 'Berlin Sans FB', family: 'Berlin Sans FB', state: false },
        { name: 'Book Antiqua', family: 'Book Antiqua', state: false },
        { name: 'Courier New', family: 'Courier New', state: false },
        { name: 'Century', family: 'Century', state: false },
        { name: 'Century Gothic', family: 'Century Gothic', state: false },
        { name: 'Bell MT', family: 'Bell MT', state: false },
        { name: 'Franklin Gothic Book', family: 'Franklin Gothic Book', state: false },
        { name: 'Candara', family: 'Candara', state: false },
        { name: 'Bookman Old Style', family: 'Bookman Old Style', state: false },
        { name: 'Impacted', family: 'Impacted', state: false },
        { name: 'Arial Narrow', family: 'Arial Narrow', state: false },
        { name: 'Gill Sans', family: 'Gill Sans', state: false },
        { name: 'Avenir Next LT Pro', family: 'Avenir Next LT Pro', state: false }
      ],
      fontSize: [],
      showFontColorPicker: false,
      showBackgroundColorPicker: false,
      color: '',
      backgroundColor: '',
      isSelectingColor: false,
      colorPickerDelay: null
    }
  },
  computed: {
    disabled () {
      if (this.element) {
        return (this.element.type === 'drop' && !this.context)
      }
      return false
    }
  },
  created () {
    this.fontSize = fontSizes.map(size => {
      return {
        value: size,
        state: false
      }
    })
  },
  mounted () {
    this.$root.$on('bv::dropdown::show', bvEvent => {
      if (bvEvent.vueTarget.id === 'font-color-picker') {
        this.showFontColorPicker = true
      } else if (bvEvent.vueTarget.id === 'background-color-picker') {
        this.showBackgroundColorPicker = true
      }
    })
    this.$root.$on('bv::dropdown::hide', bvEvent => {
      if (bvEvent.vueTarget.id === 'font-color-picker') {
        this.showFontColorPicker = false
      } else if (bvEvent.vueTarget.id === 'background-color-picker') {
        this.showBackgroundColorPicker = false
      }
    })
  },
  filters: {
    truncate: function (text, length) {
      return (text.length > length) ? text.substring(0, length) + ' ...' : text
    }
  },
  methods: {
    ...mapActions(['syncDataValue', 'setAddedToFiche', 'overwriteDroppedHeader', 'addDeletedHeader']),
    ...mapGetters(['droppedHeaders', 'isProjectTemplate']),
    handleColumnChange (column) {
      this.context = column
      if (this.context != null) {
        this.syncStateData(this.element)
      }
    },
    handleValueChange (values) {
      this.changedValue = Object.keys(values).map(key => values[key])
    },
    handleDeleteData (data) {
      this.deletedData = data
    },
    getSelectedFontFamily () {
      return this.fontFamily.find(el => el.state === true)
    },
    getSelectedBorderWidth () {
      return this.borderWidth.find(el => el.state === true)
    },
    getSelectedFontSize () {
      if (this.element.type === 'drop' && this.context) {
        return this.element.style[this.context].fontSize.replace('px', '')
      } else if (this.element.type === 'text') {
        return this.element.style.fontSize.replace('px', '')
      }
    },
    textAlignClick (type) {
      this.updateStyle('justifyContent', type)
    },
    fontSizeSelected (value) {
      this.updateStyle('fontSize', value, 'px')
    },
    fontFamilyClick (value) {
      this.updateStyle('fontFamily', value)
    },
    borderWidthClick (value) {
      this.updateStyle('borderWidth', value)
    },
    fontWeightClick () {
      const state = !this.fontWeight.state
      if (state) {
        this.updateStyle('fontWeight', 'bold')
      } else {
        this.updateStyle('fontWeight', 'normal')
      }
    },
    fontStyleClick () {
      const state = !this.fontStyle.state
      if (state) {
        this.updateStyle('fontStyle', 'italic')
      } else {
        this.updateStyle('fontStyle', 'normal')
      }
    },
    toRgbaString (color) {
      const { r, g, b, a } = color.rgba
      return `rgba(${r}, ${g}, ${b}, ${a})`
    },
    changeColor (color) {
      if (this.element.type === 'drop') {
        this.element.style[this.context].color = this.toRgbaString(color)
      }

      this.element.style.color = this.toRgbaString(color)
    },
    changeBackgroundColor (backgroundColor) {
      if (this.element.type === 'drop') {
        this.element.style[this.context].backgroundColor = this.toRgbaString(backgroundColor)
      }
      this.element.style.backgroundColor = this.toRgbaString(backgroundColor)
    },
    updateStyle (attribut, value, unit = '', skipContext = false) {
      if (this.context && !skipContext) {
        this.element.style[this.context][attribut] = `${value}${unit}`
        this.syncStateData(this.element)
        return
      }

      // this.element.style[attribut] = `${value}${unit}`
      this.$set(this.element.style, attribut, `${value}${unit}`)
      this.syncStateData(this.element)
    },
    syncStateData (newValue) {
      if (this.element.type === 'drop' && this.context) {
        this.marginTop = this.element.style.marginTop
          ? this.element.style.marginTop.replace('px', '')
          : this.marginTop
        this.marginBottom = this.element.style.marginBottom
          ? this.element.style.marginBottom.replace('px', '')
          : this.marginBottom
        this.marginRight = this.element.style.marginRight
          ? this.element.style.marginRight.replace('px', '')
          : this.marginRight
        this.marginLeft = this.element.style.marginLeft
          ? this.element.style.marginLeft.replace('px', '')
          : this.marginLeft
        this.justifyContent.forEach(el => {
          if (this.element.style[this.context].justifyContent === el.type) {
            el.state = true
            return
          }
          el.state = false
        })
        this.fontSize.forEach(el => {
          if (this.element.style[this.context].fontSize.replace('px', '') === el.value) {
            el.state = true
            return
          }
          el.state = false
        })
        this.fontFamily.forEach(el => {
          if (this.element.style[this.context].fontFamily === el.family) {
            el.state = true
            return
          }
          el.state = false
        })
        this.fontStyle.state = this.element.style[this.context].fontStyle === this.fontStyle.name
        this.fontWeight.state = this.element.style[this.context].fontWeight === this.fontWeight.name
        this.color = this.element.style[this.context].color
        return
      }
      this.paddingTop = this.element.style.paddingTop
        ? this.element.style.paddingTop.replace('px', '')
        : this.paddingTop
      this.paddingRight = this.element.style.paddingRight
        ? this.element.style.paddingRight.replace('px', '')
        : this.paddingRight
      this.paddingBottom = this.element.style.paddingBottom
        ? this.element.style.paddingBottom.replace('px', '')
        : this.paddingBottom
      this.paddingLeft = this.element.style.paddingLeft
        ? this.element.style.paddingLeft.replace('px', '')
        : this.paddingLeft
      this.marginTop = this.element.style.marginTop
        ? this.element.style.marginTop.replace('px', '')
        : this.marginTop
      this.marginBottom = this.element.style.marginBottom
        ? this.element.style.marginBottom.replace('px', '')
        : this.marginBottom
      this.justifyContent.forEach(el => {
        if (this.element.style.justifyContent === el.type) {
          el.state = true
          return
        }
        el.state = false
      })
      this.fontSize.forEach(el => {
        if (this.element.style.fontSize.replace('px', '') === el.value) {
          el.state = true
          return
        }
        el.state = false
      })
      this.fontFamily.forEach(el => {
        if (this.element.style.fontFamily === el.family) {
          el.state = true
          return
        }
        el.state = false
      })
      this.fontStyle.state = this.element.style.fontStyle === this.fontStyle.name
      this.fontWeight.state = this.element.style.fontWeight === this.fontWeight.name
      this.color = this.element.style.color
    },
    handleDropEdit (data) {
      console.log(data)
      this.element.childElements = data
    },
    handleTextEdit (value) {
      this.element.value = value
    },
    close () {
      this.$refs['editElementModal'].hide()
      this.active = false
    },
    saveChanges () {
      if (!this.isProjectTemplate()) {
        this.changedValue.forEach(el => {
          this.syncDataValue(el)
        })
        this.addDeletedHeader(this.deletedData)
      }

      this.setAddedToFiche({headerKey: this.deletedData, value: false})
      console.log(this.element)
      this.$emit('elementUpdate', this.element)
      this.close()
    },
    open (data) {
      this.element = JSON.parse(JSON.stringify(data.element))

      if (data.element.type === 'text') {
        this.syncStateData(this.element)
      }
      if (data.elindex || data.elindex === 0) {
        this.elindex = data.elindex
      }
      console.log(this.elindex)
      this.active = true
      this.$nextTick().then(() => {
        this.$refs['editElementModal'].show()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .btn-toolbar{
    .btn-group[role="group"]{
      margin: 0 5px;
    }
  }

  .slide-fade-enter-active {
    transition: all .2s ease;
  }
  .slide-fade-leave-active {
    transition: all .15s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }

  .content-editor{
    border-right: 1px solid #dee2e6;
  }

  .disabled-action {
    position: relative;
    cursor: not-allowed;
    &:before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      background-color: transparent;
      z-index: 100;
    }
    .btn-group.b-dropdown {
      color: #6c757d !important;
      border-color: #6c757d !important;
    }
    button {
      color: #6c757d;
      border-color: #6c757d;
      &.active {
        background-color: #6c757d !important;
      }
    }
  }
  ul {
    list-style: none;
    padding-left: 0;
    &.wrapper-setting {
      margin: 0;
      float: left;
      width: 100%;
      background-color: #ffffff;
    }
    .setting-option {
      border-bottom: 1px solid #ddd;
      float: left;
      display: inline-block;
      width: 95%;
      padding: 15px 2.5%;
      margin: 0;
      .option-details {
        width: 100%;
        float: left;
        display: inline-block;
        .description {
          color: #999;
          margin-bottom: 1em;
          font-size: 12px;
          font-style: italic;
        }
        h3 {
          font-size: 18px;
        }
      }
      .option-field {
        width: 100%;
        float: left;
        padding: 1.1em 0 0 10%;
        .multi-input{
          // display: inline-flex;
          input{
            margin-right: 10%;
          }
        }
        .picker-wrapper{
          display: inline-block;
          .color-picker{
            .hu-color-picker{
              box-sizing: content-box;
            }
          }
          .picker-value {
            min-height: 31px;
            border-radius: 0 !important;
            box-shadow: none !important;
            margin:0 6px 6px 0;
            padding: 0 0 0 30px;
            font-size: 11px;
            border: 1px solid #ccc;
            .picker-text{
              height: 100%;
              line-height: 30px;
              background-color: #f7f7f7;
              border-left: 1px solid #ccc;
              color: #555;
              display: block;
              padding: 0 6px;
              text-align: center;
            }
          }
        }
      }
    }
  }

  .dropdown-menu {
    padding-top: 0;
    padding-bottom: 0;
  }
  .hu-color-picker{
    box-sizing: content-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/modal/editElement.vue